<script lang="ts">
  import { useMachine } from "@xstate/svelte";
  import AnimatedBox from "../components/atoms/AnimatedBox.svelte";
  import AnimationContainer from "../components/atoms/AnimationContainer.svelte";
  import QueryClientDecorator from "../helpers/QueryClientDecorator.svelte";
  import PurchaseModuleProvider from "../providers/PurchaseModuleProvider.svelte";
  import EstimationScreen from "../screens/purchaseModule/EstimationScreen.svelte";
  import { purchaseModuleStore } from "../store/purchaseModule";
  import PriceScreen from "../screens/purchaseModule/PriceScreen.svelte";
  import { getDefaultProductOrder } from "../helpers/helperMethods";

  interface Props {
    location?: string;
    campaign: string;
    productOrder: string[] | null;
  }

  let {
    location = $bindable("/elavtal/teckna"),
    campaign,
    productOrder = $bindable(),
  }: Props = $props();

  if (productOrder == null) {
    productOrder = getDefaultProductOrder();
  }

  const machine = useMachine(purchaseModuleStore);
  const { send, state: store } = machine;

  if (campaign) {
    send("SET_CAMPAIGN", { campaign: campaign });
    if (location.charAt(location.length - 1) != "/") {
      location += "/";
    }
    location = location.concat(campaign);
  }

  if (
    $store.context.facilityInformation &&
    $store.context.facilityInformation.zipcode &&
    $store.context.facilityInformation.residenceType &&
    $store.context.estimation > 0 &&
    !$store.context.forceShowEstimation
  ) {
    send("PRICE");
  }
</script>

<QueryClientDecorator>
  <PurchaseModuleProvider {machine}>
    <AnimationContainer>
      {#if $store.value == "estimation"}
        <AnimatedBox useScroll={false}>
          <EstimationScreen />
        </AnimatedBox>
      {:else if $store.value == "price"}
        <AnimatedBox useScroll={false}>
          <PriceScreen {productOrder} {location} />
        </AnimatedBox>
      {/if}
    </AnimationContainer>
  </PurchaseModuleProvider>
</QueryClientDecorator>
